<template>
    <div class="backgroung_new">
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container shape-container d-flex">
                <div class="col px-0">
                    <div class="row">
                        <div class="col-lg-6">
                            <h1 class="display-3  text-white">{{$t('ishonch_tel.ishonch_title')}}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body style="z-index: 10;">
                    <div class="px-4">
                        <div class="text-center mt-5">
                        </div>
                        <div class="mt-1 py-5">
                            <div class="row">
                                <div class="col-lg-12">
                                    <el-collapse v-model="activeName" accordion>
                                        <el-collapse-item :title="$t('ishonch_tel.ishonch_pro_tel')" name="1" class="text-center">
                                            <h4 class="display-3 text-titlecolor title_text mb-30">{{$t('ishonch_tel.ishonch_pro')}} </h4>
                                            <template>
                                                <el-table
                                                        :data="tableData"
                                                        border
                                                        style="width: 100%">
                                                    <el-table-column
                                                            prop="numb"
                                                            label="№"
                                                            align="center"
                                                            width="50">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="organ"
                                                            :label="$t('ishonch_tel.ishonch_pro_tel1')">
                                                        <template slot-scope="{ row }">{{ $t(row.organ) }}</template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="kod"
                                                            align="center"
                                                            :label="$t('ishonch_tel.ishonch_pro_tel2')"
                                                            width="150">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="phone"
                                                            align="center"
                                                            :label="$t('ishonch_tel.ishonch_pro_tel3')"
                                                            width="250">
                                                    </el-table-column>
                                                </el-table>
                                            </template>
                                        </el-collapse-item>
                                    </el-collapse>
                                    <el-collapse v-model="activeName" accordion>
                                        <el-collapse-item :title="$t('ishonch_tel.ishonch_pro_tel6')" name="2" class="text-center">
                                            <h4 class="display-3 text-titlecolor title_text">{{$t('ishonch_tel.ishonch_pro_tel7')}}</h4>
                                            <h4 class="display-3 text-titlecolor title_text mb-30">{{$t('ishonch_tel.ishonch_pro_tel8')}}</h4>
                                            <h4 class="display-3 text-titlecolor title_text">{{$t('ishonch_tel.ishonch_pro_tel9')}} 0371 233-10-07</h4>
                                            <h4 class="display-3 text-titlecolor title_text mb-30">{{$t('ishonch_tel.ishonch_pro_tel10')}}</h4>
                                            <template>
                                                <el-table
                                                        :data="tableDataNew"
                                                        border
                                                        style="width: 100%">
                                                    <el-table-column
                                                            prop="numb"
                                                            label="№"
                                                            align="center"
                                                            width="50">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="organ"
                                                            :label="$t('ishonch_tel.ishonch_pro_tel4')">
                                                        <template slot-scope="{ row }">{{ $t(row.organ) }}</template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="phone"
                                                            align="center"
                                                            :label="$t('ishonch_tel.ishonch_pro_tel5')"
                                                            width="250">
                                                    </el-table-column>
                                                </el-table>
                                            </template>
                                        </el-collapse-item>
                                    </el-collapse>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeName: '1',
                tableData: [{
                    numb: '1',
                    organ: 'ishonch_tel.ishonch_table_row1',
                    kod: '0371',
                    phone: '232-10-07'
                }, {
                    numb: '2',
                    organ: 'ishonch_tel.ishonch_table_row2',
                    kod: '0371',
                    phone: '233-10-07'
                }, {
                    numb: '3',
                    organ: 'ishonch_tel.ishonch_table_row3',
                    kod: '0374',
                    phone: '227-10-07'
                }, {
                    numb: '4',
                    organ: 'ishonch_tel.ishonch_table_row4',
                    kod: '0365',
                    phone: '221-10-07'
                }, {
                    numb: '5',
                    organ: 'ishonch_tel.ishonch_table_row5',
                    kod: '0372',
                    phone: '226-10-07'
                }, {
                    numb: '6',
                    organ: 'ishonch_tel.ishonch_table_row6',
                    kod: '0375',
                    phone: '228-10-07'
                }, {
                    numb: '7',
                    organ: 'ishonch_tel.ishonch_table_row7',
                    kod: '0361',
                    phone: '222-10-07'
                }, {
                    numb: '8',
                    organ: 'ishonch_tel.ishonch_table_row8',
                    kod: '0436',
                    phone: '210-10-07'
                }, {
                    numb: '9',
                    organ: 'ishonch_tel.ishonch_table_row9',
                    kod: '0369',
                    phone: '227-10-07'
                }, {
                    numb: '10',
                    organ: 'ishonch_tel.ishonch_table_row10',
                    kod: '0366',
                    phone: '232-10-07'
                }, {
                    numb: '11',
                    organ: 'ishonch_tel.ishonch_table_row11',
                    kod: '0367',
                    phone: '235-10-07'
                }, {
                    numb: '12',
                    organ: 'ishonch_tel.ishonch_table_row12',
                    kod: '0376',
                    phone: '223-10-07'
                }, {
                    numb: '13',
                    organ: 'ishonch_tel.ishonch_table_row13',
                    kod: '0371',
                    phone: '271-10-07'
                }, {
                    numb: '14',
                    organ: 'ishonch_tel.ishonch_table_row14',
                    kod: '0371',
                    phone: '230-10-07'
                }, {
                    numb: '15',
                    organ: 'ishonch_tel.ishonch_table_row15',
                    kod: '0373',
                    phone: '244-10-07'
                }, {
                    numb: '16',
                    organ: 'ishonch_tel.ishonch_table_row16',
                    kod: '0362',
                    phone: '227-10-07'
                }],
                tableDataNew: [{
                    numb: '1',
                    organ: 'ishonch_tel.ishonch_table_row17',
                    phone: '0 (361) 224-75-91'
                }, {
                    numb: '2',
                    organ: 'ishonch_tel.ishonch_table_row18',
                    phone: '0 (374) 235-00-82'
                }, {
                    numb: '3',
                    organ: 'ishonch_tel.ishonch_table_row19',
                    phone: '0 (365) 224-50-26'
                }, {
                    numb: '4',
                    organ: 'ishonch_tel.ishonch_table_row20',
                    phone: '0 (372) 226-23-68'
                }, {
                    numb: '5',
                    organ: 'ishonch_tel.ishonch_table_row21',
                    phone: '0 (375) 226-05-01'
                }, {
                    numb: '6',
                    organ: 'ishonch_tel.ishonch_table_row22',
                    phone: '0 (436) 225-27-29'
                }, {
                    numb: '7',
                    organ: 'ishonch_tel.ishonch_table_row23',
                    phone: '0 (369) 234-40-36'
                }, {
                    numb: '8',
                    organ: 'ishonch_tel.ishonch_table_row24',
                    phone: '0 (366) 237-70-78'
                }, {
                    numb: '9',
                    organ: 'ishonch_tel.ishonch_table_row25',
                    phone: '0 (376) 226-11-81'
                }, {
                    numb: '10',
                    organ: 'ishonch_tel.ishonch_table_row26',
                    phone: '0 (376) 226-11-81'
                }, {
                    numb: '11',
                    organ: 'ishonch_tel.ishonch_table_row27',
                    phone: '0 (371) 250-12-24'
                }, {
                    numb: '12',
                    organ: 'ishonch_tel.ishonch_table_row28',
                    phone: '0 (373) 226-64-07'
                }, {
                    numb: '13',
                    organ: 'ishonch_tel.ishonch_table_row29',
                    phone: '0 (362) 226-22-95'
                }, {
                    numb: '14',
                    organ: 'ishonch_tel.ishonch_table_row30',
                    phone: '0 (371) 241-10-05; 241-92-05'
                }]
            };
        }
    }
</script>
<style>
</style>
